import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PutCreateRequestPreview,
	PutCreateRequestPreviewParams,
	PutCreateRequestPreviewResponse,
} from 'domain/usecases/private/refund/request-preview/put-create-request-preview';

export class RemotePutCreateRequestPreview implements PutCreateRequestPreview {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PutCreateRequestPreviewResponse>,
	) {}

	async put(params: PutCreateRequestPreviewParams): Promise<PutCreateRequestPreviewResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'put',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
